import { allIcons } from 'angular-feather/icons';
import { AnalyticsComponent } from './analytics/analytics.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountUpModule } from 'ngx-countup';
import { CrmComponent } from './crm/crm.component';
import { CryptoComponent } from './crypto/crypto.component';
import { DashboardsRoutingModule } from "./dashboards-routing.module";
import { FeatherModule } from 'angular-feather';
import { FlatpickrModule } from 'angularx-flatpickr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { JobComponent } from './job/job.component';
import { NftComponent } from './nft/nft.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { PageComponentsModule } from 'src/app/core/page-components/page-components.module';
import { ProjectsComponent } from './projects/projects.component';
import { SharedModule } from '../../shared/shared.module';
import { SimplebarAngularModule } from 'simplebar-angular';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { WidgetModule } from '../../shared/widget/widget.module';

@NgModule({
  declarations: [
    AnalyticsComponent,
    CrmComponent,
    CryptoComponent,
    JobComponent,
    NftComponent,
    ProjectsComponent
  ],
  imports: [
    CommonModule,
    CountUpModule,
    DashboardsRoutingModule,
    FeatherModule.pick(allIcons),
    FlatpickrModule.forRoot(),
    FormsModule,
    LeafletModule,
    NgApexchartsModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbPaginationModule,
    NgbToastModule,
    NgbTooltipModule,
    NgbTypeaheadModule,
    PageComponentsModule,
    ReactiveFormsModule,
    SharedModule,
    SimplebarAngularModule,
    SlickCarouselModule,
    WidgetModule
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class DashboardsModule { }
